import { useVfm } from 'vue-final-modal'
import type { SessionData } from '#auth'
import type { RewardModalProps } from '~/types/reward'
import { useNotificationsStore } from '../stores/notifications'

/**
 * The popin of the daily login point (streak) when the user data carries it: after a login, and at the first visit
 * of the day of a session still open (plugins/session.ts, the API counts that visit as the day's login)
 */
export const streakRewardData = (
  rawUser: SessionData | null | undefined,
): RewardModalProps | null => {
  const badges = rawUser?.badges_reward
  if (
    !rawUser ||
    !Array.isArray(badges) ||
    badges.length === 0 ||
    badges[0]?.category !== 'Streak'
  ) {
    return null
  }

  return {
    title: `Bienvenue ${rawUser.firstname}`,
    messages: [badges[0].descriptionHeader],
    badges,
    points: badges[0].points,
    ranking: rawUser.ranking,
    actions: [
      {
        type: 'route' as const,
        route: '/mon-profil',
        label: 'Voir mon profil',
        outline: true,
      },
      {
        type: 'route' as const,
        route: '/avantages',
        label: 'Découvrir mes avantages',
      },
    ],
  }
}

export const useManagePostLogin =
  (emit?: (evt: 'openRewardModal', data: RewardModalProps) => void) =>
  async () => {
    const notificationsStore = useNotificationsStore()

    const cookieLogin = useCookie('connected', {
      secure: import.meta.env.NODE_ENV === 'production',
      sameSite: 'lax',
      path: '/',
    })
    cookieLogin.value = 'true'

    await notificationsStore.fetchUnreadCount()

    const auth = useAuth()

    const rawUser = unref(auth.data)

    if (rawUser?.badges_reward) {
      const streakReward = streakRewardData(rawUser)
      if (streakReward) {
        return emit?.('openRewardModal', streakReward)
      } else {
        const rewardData = {
          title: `Bienvenue ${rawUser.firstname}`,
          messages: [
            'Votre inscription est à présent validée et vous rapporte des points pour le mois en cours !',
          ],
          badges: rawUser.badges_reward,
          points: rawUser.points_total,
          ranking: rawUser.ranking,
          actions: [
            {
              type: 'route' as const,
              route: '/mon-profil',
              label: 'Voir mon profil',
              outline: true,
            },
            {
              type: 'route' as const,
              route: '/avantages',
              label: 'Découvrir mes avantages',
            },
          ],
        }

        return emit?.('openRewardModal', rewardData)
      }
    }

    const route = useRoute()

    const vfm = useVfm()

    if (Object.hasOwn(route.query, 'upm')) {
      vfm.closeAll()

      return navigateTo({ path: '/mon-profil?upm' })
    }

    return vfm.closeAll()
  }
